import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPais } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class PaisService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/pais`;
  }

  getPaises(): Observable<IPais[]> {
    return this.http.get<IPais[]>(`${this.baseUrl}/public`);
  }
}
